import { Maybe } from '@types'
import { TLocaleCode } from 'constants/locales'
import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby'
import useLocale from 'hooks/useLocale'
import React, { FC } from 'react'
import { DEFAULT_LOCALE, isEmptyHeaderPage } from 'src/constants'

const LinkWithLocale: FC<LinkWithLocaleProps> = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ref,
  withLocale = true,
  replace,
  includeLangsArr = ['de', 'fr', 'es', 'it', 'pt', 'tr', 'ko', 'ru', 'fa'],
  ...other
}) => {
  const internal = /^\/(?!\/)/.test(to)
  const { locale, pathname } = useLocale()

  const pathWithOrWithoutLocale =
    locale !== DEFAULT_LOCALE && includeLangsArr.includes(locale as TLocaleCode) ? `/${locale}${to}` : to
  const url = withLocale ? pathWithOrWithoutLocale : to

  if (internal && !isEmptyHeaderPage(pathname)) {
    return (
      <GatsbyLink
        replace={replace}
        to={url}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}>
        {children}
      </GatsbyLink>
    )
  }

  const href = to === '' ? undefined : to
  return (
    <a href={href} rel='noreferrer' {...other} ref={ref}>
      {children}
    </a>
  )
}

export default LinkWithLocale

export interface LinkWithLocaleProps extends GatsbyLinkProps<any> {
  withLocale?: Maybe<boolean>
  includeLangsArr?: TLocaleCode[]
}
